(() => {
  const STORAGE_KEY = 'american-stride-delivery-zip';
  const config = document.querySelector('.custom-delivery-estimate-config');
  if (!config?.dataset.deliveryEndpoint) return;

  const normalizeZip = (value) => String(value || '').match(/^\s*(\d{5})(?:-\d{4})?\s*$/)?.[1] || '';

  const setZipValue = (field, value) => { field.textContent = value || 'Enter ZIP'; };

  const formatDate = (dateString) => {
    const [year, month, day] = dateString.split('-').map(Number);
    return new Intl.DateTimeFormat('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric',
      timeZone: 'America/Los_Angeles',
    }).format(new Date(Date.UTC(year, month - 1, day, 12)));
  };
  const fitOrderToday = (widget) => {
    const note = widget.querySelector('.custom-delivery-estimate__order-today');
    const row = widget.querySelector('.custom-delivery-estimate__date-row');
    const dates = widget.querySelector('.custom-delivery-estimate__dates');
    const base = parseFloat(getComputedStyle(widget.querySelector('form')).fontSize);
    note.style.fontSize = `${base}px`;
    if (!matchMedia('(max-width: 749px)').matches) return;
    const available = row.clientWidth - dates.getBoundingClientRect().width - 6;
    const natural = note.getBoundingClientRect().width;
    if (natural > available && available > 0) note.style.fontSize = `${Math.max(8, Math.floor(base * available / natural * 10) / 10)}px`;
    while (note.getBoundingClientRect().width > available && parseFloat(note.style.fontSize) > 8) {
      note.style.fontSize = `${Math.max(8, parseFloat(note.style.fontSize) - 0.1)}px`;
    }
  };

  const createWidget = () => {
    const element = document.createElement('div');
    element.className = 'custom-delivery-estimate';
    element.setAttribute('role', 'region');
    element.setAttribute('aria-label', 'Estimated delivery');
    element.innerHTML = `
      <div class="custom-delivery-estimate__heading">
        <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"><path d="M3 6.5h11v10H3zM14 10h3.5l3.5 3.5v3H14zM6.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM17.5 19a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z"/></svg>
        <span>Estimated Delivery</span>
      </div>
      <form class="custom-delivery-estimate__zip-form" novalidate>
        <span>Shipping to</span>
        <span class="visually-hidden" id="CustomDeliveryZipLabel">Delivery ZIP code</span>
        <button type="button" id="CustomDeliveryZip" class="custom-delivery-estimate__zip" aria-label="Edit delivery ZIP code" aria-haspopup="dialog"></button>
      </form>
      <div class="custom-delivery-estimate__date-row"><p class="custom-delivery-estimate__dates" aria-live="polite">Calculating delivery dates…</p><span class="custom-delivery-estimate__order-today">if you order today</span></div>
      <p id="CustomDeliveryStatus" class="custom-delivery-estimate__status" aria-live="polite"></p>
      <p class="custom-delivery-estimate__express">Express option available at checkout.</p>
    `;
    return element;
  };

  const requestEstimate = async (widget, requestedZip = '') => {
    const dates = widget.querySelector('.custom-delivery-estimate__dates');
    const input = widget.querySelector('.custom-delivery-estimate__zip');
    const status = widget.querySelector('.custom-delivery-estimate__status');
    const button = widget.querySelector('button');
    const zip = normalizeZip(requestedZip);

    if (requestedZip && !zip) {
      input.setAttribute('aria-invalid', 'true');
      status.textContent = 'Please enter a valid 5-digit ZIP code.';
      input.focus();
      return;
    }

    input.removeAttribute('aria-invalid');
    status.textContent = '';
    dates.textContent = 'Calculating delivery dates…';
    button.disabled = true;

    try {
      const url = new URL(config.dataset.deliveryEndpoint);
      if (zip) url.searchParams.set('zip', zip);
      const response = await fetch(url, { method: 'GET', mode: 'cors' });
      const payload = await response.json();
      if (!response.ok || !payload.ok) throw new Error(payload.error || 'Estimate unavailable');

      setZipValue(input, payload.destinationZip);
      localStorage.setItem(STORAGE_KEY, payload.destinationZip);
      dates.innerHTML = `<strong>${formatDate(payload.earliestDate)}</strong><span> to </span><strong>${formatDate(payload.latestDate)}</strong>`;
      status.textContent = '';
      return true;
    } catch {
      dates.textContent = 'Usually arrives within 3–10 business days';
      status.textContent = 'Enter your ZIP and try again for a current USPS estimate.';
      return false;
    } finally {
      button.disabled = false;
      fitOrderToday(widget);
    }
  };

  const initialize = (root = document) => {
    root.querySelectorAll('.product-form__quantity:not([data-custom-delivery-replaced])').forEach((quantity) => {
      quantity.dataset.customDeliveryReplaced = 'true';
      quantity.hidden = true;

      const widget = createWidget();
      quantity.insertAdjacentElement('beforebegin', widget);
      new ResizeObserver(() => fitOrderToday(widget)).observe(widget);
      const input = widget.querySelector('.custom-delivery-estimate__zip');
      const savedZip = normalizeZip(localStorage.getItem(STORAGE_KEY));
      const customerZip = normalizeZip(config.dataset.customerZip);
      const initialZip = savedZip || customerZip;
      if (initialZip) setZipValue(input, initialZip);
      const openEditor = () => window.customDeliveryZipEditorV1?.({
        zip: normalizeZip(input.textContent),
        endpoint: config.dataset.deliveryEndpoint,
        apply: (zip) => requestEstimate(widget, zip),
      });
      input.addEventListener('click', openEditor);
      widget.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        openEditor();
      });
      requestEstimate(widget, initialZip);
    });
  };

  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  new MutationObserver((mutations) => {
    if (mutations.some((mutation) => mutation.addedNodes.length)) initialize();
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
